import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import { TOfferSpendByAccountAggOnly, TOfferSpendByAccountDay, EOfferSpendByAccountView } from '../../types'
import { ToolPanel } from '../ui'
import { OfferSpendByAccountDetailsTable } from './OfferSpendByAccountDetailsTable'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IOfferSpendByAccountDetailsModal = {
	viewBy: EOfferSpendByAccountView;
	offerSpend: TOfferSpendByAccountDay | TOfferSpendByAccountAggOnly | null;
	show: boolean;
	take: number | 'all';
	onClose: () => void;
}

export const OfferSpendByAccountDetailsModal = (
	props: IOfferSpendByAccountDetailsModal
) => {
	const { viewBy, offerSpend, show, take = 10, onClose } = props
	const { t } = useTranslation()
	const [page, setPage] = useState<number>(0)
	const skip = (take === 'all') ? 0 : page > 0 ? page * take : 0

	const isSingleView = !!(offerSpend && ('accountId' in offerSpend))
	const accountLabel = isSingleView && `'${offerSpend?.account?.auth?.login ?? ''}' [id: ${offerSpend?.accountId ?? ''}]`
	const dayLabel = offerSpend?.day

	return <>
		<Modal show={show} onHide={onClose} size="xl" className={'modal-with-sticky scroll'}>
			<Modal.Header className={'modal-header--sticky'} closeButton>
				<Modal.Title>
					{
						isSingleView ?
							`${t(ALL_LANG_KEY.offer_spend_crud_modal.title_by_account, { account: accountLabel, date: dayLabel })}` :
							`${t(ALL_LANG_KEY.offer_spend_crud_modal.title_by_account_total, { date: dayLabel })}`
					}
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<OfferSpendByAccountDetailsTable
					items={offerSpend?.agg ?? []}
					skip={skip}
					showDateColumn={viewBy === EOfferSpendByAccountView.Month}
				/>
			</Modal.Body>

			<Modal.Footer className={'modal-footer--sticky'}>
				<ToolPanel flow="<-" width={'100%'}>
					<Button variant="secondary" onClick={onClose}>{`${t(ALL_LANG_KEY.offer_spend_crud_modal.btn_close)}`}</Button>
				</ToolPanel>

			</Modal.Footer>
		</Modal>
	</>
}
